<template>
    <div class="block-common-box">
        <TitleCommon title="About US" />
        <div class="block-common-content">
            <div class="img-box">
                <img v-for="(item,index) in imgArr" :key="index" :src="$imgUrl + item" class="img-item" alt="">
            </div>
            <div class="introduce-box">
                <h2 class="introduce-title">{{ $Getlanguage('Diverse Social and Party Space') }}</h2>
                <div class="introduce-content">
                    <p class="content-item">{{ $Getlanguage('Perrys Tokyo is a new style of social space and party venue with diverse entertainment ingredient. In the relaxed daytime, you can enjoy afternoon tea, Cake, Beer, Cocktails,Whisky, and Japanese local food.') }}</p>
                    <p class="content-item">{{ $Getlanguage('In the sensational nighttime, the light and shadow design with classic music will create a unique immersive atmosphere for your body and soul relax space.') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import TitleCommon from './TitleCommon.vue';
    const imgArr = [
        '/senceA1.png',
        // '/senceA2.png',
        '/senceA3.png',
        '/senceA1.png',
    ]
</script>

<style lang="scss" scoped>
    .block-common-content {
        width: 100%;
        height: auto;
        .introduce-box {
            width: 100%;
            .introduce-title {
                font-size: 26px;
                font-weight: 400;
                color: #e1b180;
                line-height: 40px;
                padding: 20px 0 7px;
            }
            .content-item {
                font-size: 20px;
                font-weight: 400;
                color: #ffffff;
                line-height: 40px;
            }
        }
        .img-box {
            width: 100%;
            height: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            .img-item {
                width: 32.5%;
                height: auto;
            }
        }
    }
</style>